module.exports = __webpack_public_path__ + "img/icon-record.0cd8fdbf.svg";